import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { membersFilterConfig } from '../../../configs/member-filter-config';
import { MemberFilterSelectedValues } from '../../../configs/member-filter-config/filter-selected-values';
import { leadEnglishLevelFilterConfig } from '../../../configs/lead-english-level-filter-config';
import { leadGenderFilterConfig } from '../../../configs/lead-gender-filter-config';
import { labelFilterConfig } from '../../../configs/label-filter-config';
import { LabelFilterSelectedValues } from '../../../configs/label-filter-config/filter-selected-values';
import { programFilterConfig } from '../../../configs/program-filter-config';
import { ProgramFilterSelectedValues } from '../../../configs/program-filter-config/filter-selected-values';
import { partnerFilterConfig } from '../../../configs/partner-filter-config';
import { PartnerFilterSelectedValues } from '../../../configs/partner-filter-config/filter-selected-values';
import { enrolledDateFilterConfig } from '../../../configs/enrolled-date-filter-config';

export function StageFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <InputFilterTrigger
        filterLabel='Assignee'
        config={membersFilterConfig({ facetName: 'assignee' })}
        renderValues={MemberFilterSelectedValues}
      />

      <InputFilterTrigger
        filterLabel='English Lvl'
        config={leadEnglishLevelFilterConfig}
      />

      <InputFilterTrigger
        filterLabel='Gender'
        config={leadGenderFilterConfig}
      />

      <InputFilterTrigger
        filterLabel='Label'
        config={labelFilterConfig}
        renderValues={LabelFilterSelectedValues}
      />

      <InputFilterTrigger
        filterLabel='Program'
        config={programFilterConfig}
        renderValues={ProgramFilterSelectedValues}
      />

      <InputFilterTrigger
        filterLabel='Partner'
        config={partnerFilterConfig}
        renderValues={PartnerFilterSelectedValues}
      />

      <InputFilterTrigger
        filterLabel='Enrolled Date'
        config={enrolledDateFilterConfig}
      />
    </div>
  );
}
